module.exports = __webpack_public_path__ + "img/党旗.d2153b19.png";